//引用axios
import axios from "axios";
axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

let apiBaseUrl = '/'
const requests = axios.create({
    // baseURL的作用 例如我有一个接口的网址为www.baidu/api/love
    // 如果很多接口都是www.baidu/api/xxx
    //我可以省略/api，因为axios会自动帮你添上，这就是baseUrl的作用
    baseURL: apiBaseUrl,
    //请求超时的时间为5s
    timeout: 50000,
     
  });
  //请求拦截器，发请求之前可以做一些事情
  requests.interceptors.request.use((config) => { 
    // 可使用async await 做异步操作
    // 初始化请求拦截器时，会执行此方法，此时data为undefined，赋予默认{}
    config.data = config.data || {}
  // 根据custom参数中配置的是否需要token，添加对应的请求头
  if(config?.custom?.auth) {
    // 可以在此通过vm引用vuex中的变量，具体值在vm.$store.state中
    config.header.token = vm.$store.state.userInfo.token
  }
    return config 
  }, error => { // 可使用async await 做异步操作
    return Promise.reject(error)
  })
  
  //相应拦截器
  requests.interceptors.response.use((res) => {
    // console.log(res,33)
      // 每一次需要登录的请求，更新一次token
      // if(res.headers['authorization']){
      //     localStorage.setItem('token',res.headers['authorization'])
      // }
      if (res.config.responseType === "blob") {
        let subUrl = res.config.url.substring(res.config.url.length - 13)
        // 自定义判断请求路径，可以拿到headers的值
        if (subUrl === 'downloadKmDoc') {
          return res
        }
        return res.data
      }
    
      if (res.status === 200 && res.data) {
          return Promise.resolve(res.data);
          if (res.data.code == 200) {
          } else if (res.data.code == 10001) {
              setTimeout(() => {
                  router.push({path:'/login',replace: true})
              }, 3000)
              
              return Promise.reject('登录已失效，即将跳往登录页');
          }

      } else {
    
          return Promise.reject(res.data.msg);
      }
  }, (err) => { 
      let msg = "";
      if (err && err.response) {
          switch (err.response.status) {
              case 400:
                  msg = "错误请求";
                  break;
              case 500:
                  msg = "服务器端出错";
                  break;
              
              default:
                  msg = `连接错误${err.response.status}`;
          }
      } else {
          msg = "连接到服务器失败";
      }

      return Promise.reject(msg);
  })

  export default requests